import axios from "axios";

// 规则：
// - 在 localhost 下：默认强制走相对路径交给 CRA 代理，除非显式设置 REACT_APP_FORCE_ABSOLUTE=true
// - 其他情况下：优先 REACT_APP_API_BASE，否则使用线上地址
const resolveBaseURL = (): string => {
  const isLocalhost = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  const forceAbsolute = (process.env.REACT_APP_FORCE_ABSOLUTE || "").toLowerCase() === "true";
  const fromEnv = process.env.REACT_APP_API_BASE;

  if (isLocalhost && !forceAbsolute) {
    return "/luna/api/"; // 交由 package.json 的 proxy 转发
  }

  if (fromEnv && fromEnv.trim()) {
    return fromEnv.replace(/\/+$/, "/");
  }

  return "https://www.qingcai518.com/luna/api/".replace(/\/+$/, "/");
};

const http = axios.create({
  baseURL: resolveBaseURL(),
  withCredentials: false,
});

export default http;


